import React from 'react';
import {
  Paper, TextField, FlatButton, Checkbox, AutoComplete,
} from 'material-ui';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import * as InquiryActions from '../../store/actions/InquiryActions';
import DateField from '../DateFieldComponent';
import search from '../../rest';

@connect(state => ({
  inquiry: state.Inquiry.get('inquiry').toJS(),
}))
export default class AddTraveler extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    inquiry: PropTypes.shape().isRequired,
  }

  constructor(props) {
    super(props);

    if (typeof window !== 'undefined') {
      this.ReactQuill = require('react-quill'); // eslint-disable-line global-require
    }

    const { inquiry: { travelers } } = this.props;

    let isPrimaryTraveler;
    let primaryTravelerId;
    let primaryTravelerName;
    if (travelers.length === 0) {
      isPrimaryTraveler = true;
      primaryTravelerId = '';
      primaryTravelerName = '';
    } else {
      const primary = travelers[0];
      isPrimaryTraveler = false;
      primaryTravelerId = primary.id;
      primaryTravelerName = `${primary.lastName}, ${primary.firstName}`;
    }

    this.state = {
      travelerAutocompleteData: [],
      profileAutocompleteData: [],
      dirty: false,
      firstName: '',
      lastName: '',
      email: '',
      birthdate: '',
      validDate: false,
      isAdult: true,
      insideCircle: false,
      needsTraining: false,
      needsVetting: true,
      isPrimaryTraveler,
      primaryTravelerId,
      primaryTravelerName,
      relationship: '',
      vipNotes: '',
    };
  }

  handleUpdateTravelerAutocomplete = (value) => {
    search('auto/traveler', value).then((response) => {
      const { objects } = response;
      this.setState({
        travelerAutocompleteData: objects.map((object) => {
          const emailString = object.email[0] !== '' ? ` (${object.email})` : '';
          const displayName = object.displayName || object.fullName;
          const text = `${displayName}${emailString}`;

          return {
            text,
            value: object.relayId,
            fullName: object.fullName,
            displayName: object.displayName,
            firstName: object.firstName,
            lastName: object.lastName,
            email: object.email[0],
            birthdate: object.birthdate,
            isAdult: object.adult,
            isPrimaryTraveler: object.isPrimaryTraveler,
            primaryTravelerId: object.primaryTravelerId,
            primaryTravelerName: object.primaryTravelerName,
            insideCircle: object.insideCircle,
            needsTraining: object.needsTraining,
            needsVetting: object.needsVetting,
          };
        }),
      });
    }).catch((response) => {
      console.log(response);
    });
  }

  travelerSelected = (selected, index) => {
    if (index !== -1) {
      const {
        value: id, firstName, lastName, fullName, displayName, email,
        birthdate, isAdult, isPrimaryTraveler, primaryTravelerId,
        primaryTravelerName, insideCircle, needsTraining, needsVetting,
      } = selected;

      const traveler = {
        id,
        firstName,
        lastName,
        fullName,
        displayName,
        email,
        birthdate,
        isAdult,
        isPrimaryTraveler,
        primaryTravelerId,
        primaryTravelerName,
        insideCircle,
        needsTraining,
        needsVetting,
      };

      this.props.dispatch(InquiryActions.addTraveler(traveler));
    }
  }

  handleUpdateProfileAutocomplete = (value) => {
    search('auto/traveler', `${value}&primary=true`).then((response) => {
      const { objects } = response;
      this.setState({
        primaryTravelerId: '',
        primaryTravelerName: value,
        profileAutocompleteData: objects.map(object => ({
          text: object.displayName || object.fullName,
          value: object.relayId,
          displayName: object.displayName || object.fullName,
          firstName: object.firstName,
          lastName: object.lastName,
        })),
      });
    }).catch((response) => {
      console.log(response);
    });
  }

  profileSelected = (selected, index) => {
    if (index === -1) {
      this.setState({
        primaryTravelerId: '',
        primaryTravelerName: selected,
      });
    } else {
      const { value: primaryTravelerId, displayName: primaryTravelerName } = selected;

      this.setState({
        primaryTravelerId,
        primaryTravelerName,
      });
    }
  }

  onSubmit = () => {
    const {
      firstName, lastName, email, birthdate, isAdult, insideCircle,
      needsTraining, needsVetting, isPrimaryTraveler, primaryTravelerId,
      primaryTravelerName, relationship, vipNotes,
    } = this.state;

    this.props.dispatch(InquiryActions.addTraveler({
      id: '',
      firstName,
      lastName,
      fullName: `${lastName}, ${firstName}`,
      email,
      birthdate,
      isAdult,
      insideCircle,
      needsTraining,
      needsVetting,
      isPrimaryTraveler,
      primaryTravelerId,
      primaryTravelerName,
      relationship,
      vipNotes,
    }));
  }

  onCancel = () => {
    this.props.dispatch(InquiryActions.toggleNewTraveler(false));
  }

  updateTextField = field => (e) => {
    const newState = { dirty: true };
    newState[field] = e.target.value;
    this.setState(newState);
  }

  updateBirthdate = (e) => {
    const { target: { value } } = e;
    const { isAdult } = this.state;
    const validDate = moment(value).isValid();

    this.setState({
      dirty: true,
      birthdate: value,
      validDate,
      isAdult: validDate ? moment().diff(moment(value), 'years') > 17 : isAdult,
    });
  }

  handleCheckbox = fieldname => (e, checked) => {
    const newState = { dirty: true };

    if (fieldname === 'isPrimaryTraveler' && checked) {
      newState.primaryTravelerId = '';
      newState.primaryTravelerName = '';
      newState.relationship = '';
    }

    newState[fieldname] = checked;
    this.setState(newState);
  }

  handleVipNotes = (vipNotes) => {
    this.setState({
      vipNotes,
      dirty: true,
    });
  }

  render() {
    const {
      dirty, firstName, lastName, email, isAdult, insideCircle,
      needsTraining, needsVetting, validAdult, primaryTravelerName,
      relationship, isPrimaryTraveler, vipNotes, travelerAutocompleteData,
      profileAutocompleteData, birthdate,
    } = this.state;

    const ready = dirty && (birthdate === '' || moment(birthdate).isValid());

    return (<Paper className={css(styles.addBox)}>
      <AutoComplete
        hintText='Search for an existing traveler'
        menuStyle={{ width: 500 }}
        listStyle={{ width: 500 }}
        dataSource={travelerAutocompleteData}
        onUpdateInput={this.handleUpdateTravelerAutocomplete}
        onNewRequest={this.travelerSelected}
        fullWidth
        filter={() => true}
      />
      <div className={css(styles.formRow)}>
        <TextField floatingLabelText='First name' onChange={this.updateTextField('firstName')} value={firstName} />
        <TextField floatingLabelText='Last name' onChange={this.updateTextField('lastName')} value={lastName} />
        <TextField floatingLabelText='Email Address' onChange={this.updateTextField('email')} value={email} />
      </div>
      <div className={css(styles.formRow)}>
        <DateField className={css(styles.birthdate)} floatingLabelText='Birthdate' onChange={this.updateBirthdate} />
        <Checkbox checked={isAdult} label='Adult' className={css(styles.checkBox)} disabled={validAdult} onCheck={this.handleCheckbox('isAdult')} />
        <div className={css(styles.checkBox)} />
      </div>
      <div className={css(styles.formRow)}>
        <Checkbox checked={insideCircle} label='Inside Circle' className={css(styles.checkBox)} onCheck={this.handleCheckbox('insideCircle')} />
        <Checkbox checked={needsTraining} label='Needs Training' className={css(styles.checkBox)} onCheck={this.handleCheckbox('needsTraining')} />
        <Checkbox checked={needsVetting} label='Needs Vetting' className={css(styles.checkBox)} onCheck={this.handleCheckbox('needsVetting')} />
      </div>
      <div className={css(styles.formRow)}>
        <Checkbox checked={isPrimaryTraveler} label='Primary Traveler' className={css(styles.checkBox)} onCheck={this.handleCheckbox('isPrimaryTraveler')} />
        <AutoComplete
          floatingLabelText='CB+ Profile Name'
          menuStyle={{ width: 500 }}
          listStyle={{ width: 500 }}
          searchText={primaryTravelerName}
          dataSource={profileAutocompleteData}
          onUpdateInput={this.handleUpdateProfileAutocomplete}
          onNewRequest={this.profileSelected}
          disabled={isPrimaryTraveler}
          filter={() => true}
        />
        <TextField floatingLabelText='Relationship' onChange={this.updateTextField('relationship')} value={relationship} disabled={isPrimaryTraveler} />
      </div>
      <div>
        <h2>VIP Notes</h2>
        <this.ReactQuill value={vipNotes} onChange={this.updateVipNotes} />
      </div>
      <div className={css(styles.controls)}>
        <FlatButton label='Cancel' onTouchTap={this.onCancel} secondary />
        <FlatButton label='Submit' onTouchTap={this.onSubmit} primary disabled={!ready} />
      </div>
    </Paper>);
  }
}

const styles = StyleSheet.create({
  addBox: {
    marginLeft: 15,
    flexGrow: 1,
    padding: '0 15px 15px 15px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 839,
  },
  formRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  checkBox: {
    width: 256,
  },
  birthdate: {
    marginBottom: 15,
  },
});



// WEBPACK FOOTER //
// /src/components/Inquiry/AddTraveler.js